import { useState } from "react";
import { IMaskInput } from "react-imask";

import styles from "./input.module.css";

export default function Input({ style, onChange, value, label, name, mask, options, placeholder, isError, error, subLabel, type, onSelect, disabled, isTextarea }) {
  const [isOptions, setIsOptions] = useState(false)

  return (
    <div className={styles.container} style={style ? style : { display: "flex" }}>
      {label && <label className={isError && styles.error}>{label}</label>}
      { isTextarea ? (
          <textarea
            disabled={disabled}
            name={name}
            className={`${styles.input} ${styles.textarea} ${isError ? styles.error : styles.okay}`}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
          />
        ) : (
          mask ? (
            <IMaskInput
              mask={mask}
              name={name}
              className={styles.input}
              value={value}
              type={type}
              onAccept={(value) => onChange(value)}
              onClick={() => setIsOptions(!isOptions)}
              placeholder={placeholder}
            />
          ) : (
            <input
              disabled={disabled}
              name={name}
              className={`${styles.input} ${isError ? styles.error : styles.okay}`}
              value={value}
              type={type}
              onChange={(e) => onChange(e.target.value)}
              onClick={() => setIsOptions(!isOptions)}
              placeholder={placeholder}
            />
          )
        )
      }
      {(isOptions && options &&
        <div className={styles.options}>
          {options.map((x) =>
            <span
              onClick={(e) => {
                onSelect(x);
                setIsOptions(false);
                e.preventDefault()
              }}
            >
              {x.Note}
            </span>
          )}
          {options.length === 0 &&
            <span>Не найдено</span>
          }
        </div>
      )}
      {isError && <span className={styles.error}>{error}</span>}
      {subLabel && <label className={subLabel}>{subLabel}</label>}
    </div>
  )
}